// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ICreateQuestionRequest,
  TCreateQuestionModel,
  IMappers,
  TCreateQuestionResponse,
  ICreateQuestionResponse,
  ICreateQuestionResponseError,
} from './types';

export const defaultConfig: TCreateQuestionModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-reviews',
  pathApi: '/v1/create-question/',
  requestType: 'json',
} as TCreateQuestionModel;

export function createCreateQuestionModel(parameters: ICreateQuestionRequest): TCreateQuestionModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateQuestionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ICreateQuestionRequest;
}

export async function fetchCreateQuestion<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateQuestionOptions<TResponse200, TResponse400>): Promise<TCreateQuestionResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createCreateQuestionModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateQuestionResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ICreateQuestionResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCreateQuestionResponse;
}
